export class DateTimeUtil {

  public static getCurrentTimestamp(): number {
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date.getTime() / 1000;
  }

  public static toLocalTimeZone(date: Date): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(),
      date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  }

  public static getCurrentTimezone(): number {
    return (new Date().getTimezoneOffset() / 60) * -1;
  }

  public static getCurrentFormatTimezone(): string {
    let timezone = this.getCurrentTimezone();
    let sign = '+';

    if (timezone < 0) {
      sign = '-';
      timezone = timezone * -1;
    }

    return sign + (new Date(timezone * 60 * 60 * 1000).toISOString().substr(11, 5));
  }
}
